import SettingsItemText from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsItemText";
import SettingsSection from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsSection";
import { useEditor, useNode } from "@craftjs/core";
import { Grid } from "@mui/material";

const Settings = () => {
    const { id } = useNode();
    const { displayName, tag, actions } = useEditor((state) => ({
        displayName:
            state.nodes[id] && state.nodes[id].data.custom.displayName
                ? state.nodes[id].data.custom.displayName
                : state.nodes[id].data.displayName,
        tag: state.nodes[id].data.props.tag,
    }));

    return (
        <>
            <SettingsSection
                title="Identification"
                summary={() => {
                    return `${displayName || "-"}`;
                }}
            >
                <Grid size={{ xs: 12 }}>
                    <SettingsItemText
                        type={"text"}
                        value={displayName}
                        onChange={(value: string) => {
                            actions.setCustom(id, (custom) => (custom.displayName = value));
                        }}
                        fullWidth={true}
                        label="Display name"
                        disabled={true}
                    />
                </Grid>
            </SettingsSection>
            <SettingsSection
                title="Options"
                summary={() => {
                    return `Tag: ${tag || "-"}`;
                }}
            >
                <Grid size={{ xs: 12 }}>
                    <SettingsItemText
                        type={"text"}
                        value={tag}
                        onChange={(value: string) => {
                            actions.setProp(id, (custom) => (custom.tag = value));
                        }}
                        fullWidth={true}
                        label="Tag"
                    />
                </Grid>
            </SettingsSection>
        </>
    );
};

export default Settings;
